import styled from 'styled-components'
import { buttonGreen, heading2 } from 'app/sofia/resources/theme/css'
import { containerCss } from 'app/sofia/components/Structure/Container'
import { font, bp } from 'lib/core/resources/helpers/styled'
import { BP } from 'resources/constants'
import Shape from 'resources/svg/featuredPosts-shape.svg'

export const Container = styled.div`
  position: relative;

  &::after {
    content: '';
    width: 300px;
    height: 500px;
    position: absolute;
    background: url(${Shape}) no-repeat left top;
    bottom: -150px;
    right: 0;
    z-index: 3;
    ${bp('sm')`
      content: unset;
    `}
  }

  > div {
    ${containerCss};
    text-align: center;
    max-width: ${BP.md.max};
    padding: 70px 15px;
  }

  a {
    text-decoration: none;
    color: ${props => props.theme.palette.general.strong};
  }

  h2 {
    ${heading2};
    line-height: 1.2;
    margin: 0 0 8px;

    br {
      display: none;

      @media (min-width: ${BP.xs.min}) {
        display: block;
      }
    }
  }

  > div > p {
    margin: 0 0 75px;
  }

  .cards {
    @media (min-width: ${BP.sm.min}) {
      display: flex;
      justify-content: center;
    }

    @media (min-width: ${BP.md.min}) {
      max-width: 80%;
      margin: 0 auto;
    }
  }

  .card {
    text-align: center;
    padding: 25px 35px;
    border-radius: 5px;
    box-shadow: ${props => props.theme.palette.general.boxShadow};
    box-sizing: border-box;
    background-color: ${props => props.theme.palette.general.light};
    counter-increment: number;
    position: relative;
    padding-top: 50px;
    margin-bottom: 40px;

    &:last-child {
      margin-bottom: 0;
    }

    @media (min-width: ${BP.sm.min}) {
      flex: 1;
      margin: 0 10px;
    }

    @media (min-width: ${BP.lg.min}) {
      margin: 0 20px;
    }

    &::before {
      content: counter(number);
      position: absolute;
      top: -25px;
      left: 0;
      right: 0;
      text-align: center;
      width: 50px;
      height: 50px;
      border: 3px solid ${props => props.theme.palette.general.light};
      box-shadow: ${props => props.theme.palette.general.boxShadow};
      border-radius: 100%;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      font: ${font('default', 'normal', '30px/1')};
      color: ${props => props.theme.palette.general.light};
    }

    &:first-child {
      &::before {
        background-color: ${props => props.theme.palette.primary.beta};
      }
    }

    &:nth-child(2) {
      &::before {
        background-color: ${props => props.theme.palette.primary.gammaLight};
      }
    }

    &:nth-child(3) {
      &::before {
        background-color: ${props => props.theme.palette.primary.alphaMutted};
      }
    }

    img {
      max-width: 80px;
      height: 85px;
    }

    h3 {
      font: ${font('alt', 'normal', '19px/1')};
    }

    p {
      font: ${font('default', 'light', '16px/1.3')};
      margin-bottom: 0;
    }
  }

  .button {
    ${buttonGreen}
    background-color: ${props => props.theme.palette.primary.beta};
    margin: 25px 0 0;
    position: relative;
    z-index: 2;

    @media (min-width: ${BP.sm.min}) {
      margin: 40px 0;
    }
  }
`
